import type {
  OnInit} from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'ppl-items-nav',
    templateUrl: './items-nav.component.html',
    styleUrls: ['./items-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ItemsNavComponent implements OnInit {

  @Input() value: string;
  @Input() items: ItemsNavItem[];
  @Input() disabled = false;

  @Output() itemClick = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  trackBy(index: number, item: ItemsNavItem) {
    return item.value;
  }

  onItemClick(item: ItemsNavItem) {
    if (!this.disabled) {
      this.itemClick.emit(item.value);
    }
  }

}

export interface ItemsNavItem {
  value: string;
  label: string;
  icon: string;
}
